<template>
  <div>Not found: {{pathMatch}}</div>
</template>

<script>
export default {
  props: {
    pathMatch: {
      type: String,
      required: true
    }
  }
};
</script>